import {
	DataDeclarationTct,
	DeclarationType,
	PatchDeclarationsDto,
} from '@dealstack/shared/lib/generated';
import { DeclarationsEditFormValues } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/ReviewKycWorkflow/component/StepContent/component/Declarations/DeclarationsEditForm.types';

export const SOURCE_OF_FUNDS_TYPES: DeclarationType[] = [
	DeclarationType.SOURCE_OF_FUNDS_SALARY,
	DeclarationType.SOURCE_OF_FUNDS_INHERITANCE,
	DeclarationType.SOURCE_OF_FUNDS_INVESTMENT_INCOME,
	DeclarationType.SOURCE_OF_FUNDS_PERSONAL_SAVINGS,
	DeclarationType.SOURCE_OF_FUNDS_OTHER,
];

// Source-of-funds checkboxes; labels reuse the investor-side i18n keys so both sides stay in sync.
export const FUNDS_CHECKBOXES: { value: DeclarationType; labelKey: string }[] = [
	{
		value: DeclarationType.SOURCE_OF_FUNDS_SALARY,
		labelKey: 'investment.join.kyc.declarations.funds.label_1',
	},
	{
		value: DeclarationType.SOURCE_OF_FUNDS_INHERITANCE,
		labelKey: 'investment.join.kyc.declarations.funds.label_2',
	},
	{
		value: DeclarationType.SOURCE_OF_FUNDS_INVESTMENT_INCOME,
		labelKey: 'investment.join.kyc.declarations.funds.label_3',
	},
	{
		value: DeclarationType.SOURCE_OF_FUNDS_PERSONAL_SAVINGS,
		labelKey: 'investment.join.kyc.declarations.funds.label_4',
	},
	{
		value: DeclarationType.SOURCE_OF_FUNDS_OTHER,
		labelKey: 'investment.join.kyc.declarations.funds.label_5',
	},
];

export const declarationsToFormValues = (
	declarations: DataDeclarationTct[] = []
): DeclarationsEditFormValues => {
	const sourceOfFunds: DeclarationType[] = [];
	let beneficialOwnership = false;
	let isPoliticallyExposedPerson: boolean | undefined;
	let pepDetails = '';
	let sourceOfFundsOtherDetails = '';

	for (const declaration of declarations) {
		if (declaration.type === DeclarationType.BENEFICIAL_OWNERSHIP) {
			beneficialOwnership = declaration.checked;
		} else if (declaration.type === DeclarationType.POLITICALLY_EXPOSED_PERSON) {
			isPoliticallyExposedPerson = declaration.checked;
			pepDetails = declaration.description ?? '';
		} else if (SOURCE_OF_FUNDS_TYPES.includes(declaration.type) && declaration.checked) {
			sourceOfFunds.push(declaration.type);
			if (declaration.type === DeclarationType.SOURCE_OF_FUNDS_OTHER) {
				sourceOfFundsOtherDetails = declaration.description ?? '';
			}
		}
	}

	return {
		beneficialOwnership,
		sourceOfFunds,
		sourceOfFundsOtherDetails,
		isPoliticallyExposedPerson,
		pepDetails,
	};
};

export const formValuesToDeclarationsPayload = (
	values: DeclarationsEditFormValues
): PatchDeclarationsDto => {
	const sourceOfFunds = values.sourceOfFunds ?? [];
	const isChecked = (type: DeclarationType) => sourceOfFunds.includes(type);

	return {
		beneficialOwnership: !!values.beneficialOwnership,
		sourceOfFundsSalary: isChecked(DeclarationType.SOURCE_OF_FUNDS_SALARY),
		sourceOfFundsInheritence: isChecked(DeclarationType.SOURCE_OF_FUNDS_INHERITANCE),
		sourceOfFundsInvestmentIncome: isChecked(DeclarationType.SOURCE_OF_FUNDS_INVESTMENT_INCOME),
		sourceOfFundsPersonalSavings: isChecked(DeclarationType.SOURCE_OF_FUNDS_PERSONAL_SAVINGS),
		sourceOfFundsOther: isChecked(DeclarationType.SOURCE_OF_FUNDS_OTHER),
		sourceOfFundsOtherDescription: values.sourceOfFundsOtherDetails ?? '',
		politicallyExposedPerson: !!values.isPoliticallyExposedPerson,
		politicallyExposedPersonDescription: values.pepDetails ?? '',
	};
};
